import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import no from "./locales/no.json";
import sv from "./locales/sv.json";
import da from "./locales/da.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = [
  { code: "no", name: "Norsk",   flag: "🇳🇴" },
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "da", name: "Dansk",   flag: "🇩🇰" },
  { code: "en", name: "English", flag: "🇬🇧" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      no: { translation: no },
      sv: { translation: sv },
      da: { translation: da },
      en: { translation: en },
    },
    fallbackLng: "no",
    supportedLngs: ["no", "sv", "da", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "ui_language",
    },
    returnEmptyString: false,
    react: { useSuspense: false },
  });

export default i18n;
